export default {
  600: '参数错误',
  510007: '没有权限',
  510008: '未登录',
  510009: '用户不存在',
  510010: '系统错误，请稍后重试',
  510011: '平台参数错误',
  510012: '非法访问',
  510015: '00:00-07:00期间系统升级中，由此给您带来不便，敬请谅解！',
  511001: '图形验证码错误',
  511002: '动态密码错误',
  511003: '账号密码错误',
  511004: '您的账号由于不合规操作，已被封停！',
  511005: '用户Token缺失',
  511006: '用户Token认证失败',
  511007: '用户Token已过期，请重新登录',
  511008: '数据不存在',
  511009: '验证码错误',
  511010: '用户注册中心注册失败',
  511011: '用户已存在',
  511012: '上一步操作结果，验证失败',
  511013: '旧密码不能为空',
  511014: '旧密码错误',
  511015: '密码输入不一致',
  511016: '手机号格式错误',
  511017: '邮箱格式错误',
  511018: '验证码错误',
  511019: '发送短信验证码失败',
  511022: '该手机号已存在',
  511023: '该邮箱已存在',
  511024: '请勿短时间内重复请求',
  511025: '上传头像异常',
  511026: '当前第三方用户已创建,密码数据不一致,请使用更新接口修改数据',
  511027: '当前用户已在SAAS平台上删除, 请先恢复',
  511028: '第三方用户对象不存在',
  511032: '密码已存在，不允许直接设置',
  511033: '没有权限访问',
  511034: '无效的信息',
  511036: '用户存在',
  511037: '上传图片过大',
  511038: '上传文件类型不支持',
  511039: '当前账号已绑定，请先解绑',
  511041: '第三方账号信息缺失，请重新扫码',
  511042: '已被其他账号绑定',
  511043: '接口访问次数达到最大值限制',
  511044: '数据签名错误',
  511045: '数据异常，当前登录用户不存在',
  511046: '签名参数缺失',
  511055: '手机号未注册',
  511057: '请输入正确验证码',
  511058: '无效的Token',
  511065: '登录请求已过期，请重新登录',
  511066: '数据签名错误!',
  511075: '请填写本人手机号',
  511076: '数据正在迁移中，暂不可访问页面',
  511078: '邮箱不能为空',
  511079: '当前账号禁止登录，请联系客服人员',
  511087: '用户未注册',
  512002: '此视频已下线',
  512017: '白名单观众不存在',
  512029: '此专题已下线',
  512033: '回放内容不存在',
  512037: '白名单用户不存在',
  512042: '图片验证码错误',
  512051: '活动最高并发超出限制',
  512063: '该专题已经下线',
  512505: '没有找到房间',
  512506: 'live_token已过期',
  512507: 'live_token错误或已失效',
  512514: '您已被禁止访问当前活动',
  512515: '未找到参会数据',
  512516: '该账号已进入直播',
  512521: '直播未开始',
  512522: '主持人、嘉宾或助理直播时不能进入观看端',
  512523: '需要付费',
  512524: '被转播活动未开始直播',
  512525: '需要填写报名表单',
  512526: '检测类型和活动观看限制类型不一致',
  512527: '密码错误',
  512528: '请输入密码',
  512529: '邀请码错误',
  512530: '邀请码已被使用',
  512531: '请输入邀请码',
  512532: '请输入白名单手机号|邮箱|工号|其它',
  512535: '组织者对该活动设置了验证机制',
  512536: '回放内容不存在',
  512538: '组织者对该活动设置了验证机制，验证失败',
  512539: '验证方式只支持免费、密码和第三方K值',
  512540: '活动已结束',
  512541: '活动现场太火爆，已超过人数上限！',
  512542: '访客数据信息不全',
  512543: '此视频已下线',
  512544: '该视频已下线，有疑问请联系客服',
  512545: '该视频转码失败',
  512546: '该视频正在转码中',
  512561: '流信息不存在',
  512570: '短信验证码错误',
  512571: '流量用户欠费超过100G，暂不能进入',
  512573: '邮箱已被他人使用',
  512579: '活动被管理员封禁',
  513025: '上麦席位已满员，您的账户支持{n}人上麦',
  513345: '您正在轮巡中，暂不能上麦',
  513533: '无效的参会token信息',
  513534: '当前活动类型不匹配，禁止操作',
  513535: '未获取到主持人信息',
  513536: '活动不匹配',
  513537: '当前用户无权限',
  513548: '打赏金额超出限制',
  513550: '无效的图片路径',
  514004: '当前上传类型，含有不被允许类型',
  514005: '当前上传类型不被允许',
  514006: '上传路径中含有特殊字符',
  514007: '上传文件不存在',
  514008: '上传文件不能超过2M',
  514009: '上传文件过大',
  514014: '授权失败，请刷新重试',
  516000: '未知错误',
  516002: '用户不存在',
  516005: '签名校验失败',
  516300: '请先绑定手机号',
  516301: '验证码校验失败，请重试',
  516305: '短信验证码校验失败',
  516307: '提现金额不能小于1元',
  516308: '提现金额不能大于余额',
  516312: '您有进行中的提现，无法再次提现',
  516313: '超过线上单笔最大提现额度，请走线下提现流程',
  516820: '提现金额不能小于1元',
  516824: '添加申请提现金额不能大于用户账户余额',
  516825: '用户账户余额小于0元',
  516826: '发送短信校验码失败！',
  516829: '提现,转账失败'
};
